module.exports = __webpack_public_path__ + "media/recipes/50-a3f38c84.png";